module.exports = __webpack_public_path__ + "static/media/floryptus-logo-slogan.7916b920.svg";